export default __webpack_public_path__ + "static/media/calendar.c93db01e.svg";